import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from './Icon';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';
export function Notice({ tone = 'info', title, children, live = false }) {
    const polite = live === 'polite';
    return (_jsxs(Alert, { variant: tone === 'error' ? 'destructive' : 'default', "data-notice": tone, role: live === false ? undefined : polite ? 'status' : 'alert', "aria-live": live === false ? undefined : polite ? 'polite' : 'assertive', children: [_jsx(Icon, { name: tone }), title !== undefined ? _jsx(AlertTitle, { children: title }) : null, _jsx(AlertDescription, { children: children })] }));
}
//# sourceMappingURL=Notice.js.map